import Flickity from "flickity";

const initRelatedNews = (sections) => {
    sections.forEach((section) => {
        const flkty = new Flickity(section, {
            draggable: true,
            watchCSS: true,
            pageDots: false,
            prevNextButtons: false,
            cellAlign: 'left',
        });
    });
};

export default initRelatedNews;
